import { useEffect } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Route, Switch, Redirect, Link, useLocation } from "react-router-dom";
import Contactus from './pages/contact_us';
import Index from './pages/index';
import Capabilities from './pages/capabilities';
import DoWeFit from './pages/dowefit';
import NoMatch from './pages/nomatch'; // 404 page
import MachineControl from './pages/machine-control'
//import sunWalker from './pages/sunwalker';
import ReactGA from 'react-ga';

const PageviewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.pageview(location.pathname);
  }, [location.pathname]);

  return null;
}

const Navigation = () => {
    return (
      <>
          <PageviewTracker />
          <Navbar variant="dark" expand="lg" className="headernavbar sticky-top">
            <Navbar.Brand as={Link} to="/"><span className="topleftlogo"></span></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav>
                <Nav.Item>
                <Nav.Link as={Link} className="homeLink nav-link" to="/">HOME</Nav.Link>
                </Nav.Item>
                <NavDropdown title="PRODUCTS AND CAPABILITIES" id="basic-nav-dropdown">
                  <NavDropdown.Item as={Link} className="nav-link" to="/capabilities">What we are capable of</NavDropdown.Item>

                  <NavDropdown.Item as={Link} className="nav-link" to="/machine-control">Engenious Machine Control</NavDropdown.Item>
 { /*               <NavDropdown.Item className="nav-link" href="/sunwalker">Sunwalker Crosswalk System</NavDropdown.Item> */ }

                  {/*   <NavDropdown.Item className="nav-link" href="/crosswalk-flasher">Sunwalker Crosswalk Flasher</NavDropdown.Item>
               */}
                </NavDropdown>
                <Nav.Item>
                <Nav.Link as={Link} className="nav-link" to="/why-us">WHY US</Nav.Link>
                </Nav.Item>
                <Nav.Item>

                <Nav.Link as={Link} className="nav-link contactUs" to="/contact-us" ><div>CONTACT US</div></Nav.Link>
                </Nav.Item>
              </Nav>

            </Navbar.Collapse>
          </Navbar>

          <Switch>
            <Route path="/" exact component={Index} />
            <Route path="/capabilities" component={Capabilities} />
            <Route path="/contact-us" component={Contactus} />
            <Route path="/why-us" component={DoWeFit} />
  {/*       <Route path="/digi-start" component={DigiStart} />
            <Route path="/digi-brake" component={DigiBrake} />
            <Route path="/sunwalker" component={sunWalker} /> */}
            <Route path="/machine-control" component={MachineControl} />

            <Route path="/404.html" component={NoMatch} />
            <Redirect to="/404.html" />
          </Switch>

      </>
    );
  }

export default Navigation;
